import * as angular from "angular";
import {ProgressHeaderController} from "./progress-header.controller";
const templateUrl = require("./progress-header.html");

export const progressHeader: angular.IComponentOptions = {
    templateUrl,
    controller: ProgressHeaderController,
    controllerAs: "vm",
    bindings: {
        isImportComplete: "<",
        startedOn: "<",
        completedOn: "<",
        totalSchools: "<",
        totalSchoolsCompleted: "<",
        isTest: "<?"
    }
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/progress-header/progress-header.ts